import Api from "@/services/api";
import { PlayerMonitor } from "@/services/players/types";

export async function getPlayerMonitor(id: string): Promise<PlayerMonitor> {
    return new Promise((resolve, reject) => {
        Api.get(`/playerMonitor/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAllPlayerMonitors(): Promise<Array<PlayerMonitor>> {
    return new Promise((resolve, reject) => {
        Api.get("/playerMonitor").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function createPlayerMonitor(playerMonitor: PlayerMonitor): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.post("/playerMonitor", playerMonitor).then(
            response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export async function updatePlayerMonitor(playerMonitor: PlayerMonitor): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.put("/playerMonitor", playerMonitor).then(
            response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export async function deletePlayerMonitor(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.delete(`/playerMonitor/${id}`).then(
            response => {
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
}
